import React from 'react';
import PropTypes from 'prop-types';
import { DefaultButton, PrimaryButton, Checkbox, TextField } from '@bingads-webui-react/fabric-control';

const Checkboxes = ({ checkboxOption, toggleCheckbox }) => (
  <div className="checkbox-container">
    {checkboxOption.map(entry => (
      <Checkbox
        label={entry.text}
        onChange={toggleCheckbox}
        id={entry.key}
        key={entry.key}
        name={entry.name}
      />))
        }
  </div>);

const checkboxesPropType = {
  checkboxOption: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
  toggleCheckbox: PropTypes.func.isRequired,
};

Checkboxes.propTypes = checkboxesPropType;

const CommentContainer = ({
  i18n,
  onChange,
}) => (
  <div className="comment-container">
    <TextField
      className="comment-textarea"
      multiline
      resizable={false}
      placeholder={i18n.getString('Fluctuation_Comment_Placeholder')}
      onChange={onChange}
    />
  </div>
);

CommentContainer.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export const DismissForm = ({
  i18n,
  checkboxOption,
  toggleCheckbox,
  handleCommentChange,
  onSubmit,
  onCancel,
}) => (
  <div className="dismiss-container">
    <div className="form-container">
      <Checkboxes checkboxOption={checkboxOption} toggleCheckbox={toggleCheckbox} />
      <CommentContainer i18n={i18n} onChange={handleCommentChange} />
      <div className="dismiss-message">{i18n.getString('Fluctuation_Dismiss_Explanation')}</div>
      <div className="fluctuation-button-container">
        <PrimaryButton className="btn btn-primary btn-dismiss" onClick={onSubmit} text={i18n.getString('Fluctuation_Button_Dismiss')} />
        <DefaultButton className="btn btn-default btn-dismiss-cancel" onClick={onCancel} text={i18n.getString('Fluctuation_Button_Cancel')} />
      </div>
    </div>

  </div>
);

const commonProptypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  ...checkboxesPropType,
  handleCommentChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

DismissForm.propTypes = commonProptypes;

export const FeedbackForm = ({
  i18n,
  checkboxOption,
  toggleCheckbox,
  handleCommentChange,
  onSubmit,
  onCancel,
  selectedCheckboxes,
  comment,
}) => (
  <div className="feedback-container">
    <div className="form-container">
      <Checkboxes checkboxOption={checkboxOption} toggleCheckbox={toggleCheckbox} />
      <CommentContainer i18n={i18n} onChange={handleCommentChange} />
      <div className="fluctuation-button-container">
        <PrimaryButton
          className="btn btn-primary btn-submit"
          disabled={!selectedCheckboxes.length && !comment}
          type="submit"
          onClick={onSubmit}
          text={i18n.getString('Fluctuation_Button_Submit')}
        />
        <DefaultButton className="btn btn-default btn-cancel" onClick={onCancel} text={i18n.getString('Fluctuation_Button_Cancel')} />
      </div>
    </div>
  </div>
);

FeedbackForm.propTypes = {
  ...commonProptypes,
  selectedCheckboxes: PropTypes.arrayOf(PropTypes.string).isRequired,
  comment: PropTypes.string.isRequired,
};
